// extracted by mini-css-extract-plugin
export default {"tablehead":"Tablepallets_tablehead__LXAoa","custom-striped-table":"Tablepallets_custom-striped-table__33IH-"};